

export default function parseLimit(sql, transform) {
  sql.limit += transform.row;
  sql.offset += transform.offset || sql.offset;
  return sql;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mapd-data-layer-2/es/parser/parse-limit.js
// module id = 127
// module chunks = 0 1